// Enormity (Jupiter): long words score more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const enormity: AlignmentDef = {
  id: 'enormity',
  planet: 'jupiter',
  name: 'Enormity',
  text: () => `Words of ${N.enormityLength} letters or more score +${N.enormityPercent}%.`,
  wordPercent: (c) => (c.nodes.length >= N.enormityLength ? N.enormityPercent : 0),
};
